import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import React from 'react';

import { EmspBoEmspUserAuthenticatorListController } from '../../../emsp-bo-emsp-user-authenticator-list/emsp-bo-emsp-user-authenticator-list.controller';
import { EmspBoEmspUserConsentListController } from '../../../emsp-bo-emsp-user-consent-list/emsp-bo-emsp-user-consent-list.controller';
import { EmspBoEmspUserOcpiTokenListController } from '../../../emsp-bo-emsp-user-ocpi-token-list/emsp-bo-emsp-user-ocpi-token-list.controller';
import { EmspBoEmspUserPreferenceListController } from '../../../emsp-bo-emsp-user-preference-list/emsp-bo-emsp-user-preference-list.controller';
import { GeneralCardComponent } from './cards/general-card.component';

export const InformationTabComponent = (): React.JSX.Element => (
  <Stack direction="row" gap={GapEnum.L}>
    <Stack direction="column" gap={GapEnum.L} flex={1}>
      <GeneralCardComponent />
      <EmspBoEmspUserPreferenceListController />
    </Stack>
    <Stack direction="column" gap={GapEnum.L} flex={1}>
      <EmspBoEmspUserConsentListController />
      <EmspBoEmspUserOcpiTokenListController />
      <EmspBoEmspUserAuthenticatorListController />
    </Stack>
  </Stack>
);
